import React, { useState } from 'react';
import '../styles/Home.css';
import { Link } from 'react-router-dom';

const Home = () => {
  const [showBanner, setShowBanner] = useState(true);
  const [showOffers, setShowOffers] = useState(false); // state for offer visibility

  const handleCloseBanner = () => {
    setShowBanner(false);
  };

  const toggleOffers = () => {
    setShowOffers(!showOffers);
  };

  return (
    <div className="home-container">

   {/* {showBanner && ( 
    //     <div className="popup-overlay">
    //       <div className="popup-banner">
    //         <span className="close-button" onClick={handleCloseBanner}>&times;</span>
    //         <div className="popup-content">
    //           <h2>🎮 Game Launch Alert!</h2>
    //           <p>
    //             PS4, PS5 & PC Games now live at SnookerHut! Book your slots and grab launch offers. <br />
    //             <strong className="offerupdate">40% off till June 15th!!</strong>
    //           </p>
    //           <Link to="/bookinggames" className="popup-link">Book Now</Link>
    //         </div>
    //       </div>
    //     </div>
    //   )}*/}

      <header>
        <h1>Welcome to SnookerHut</h1>
        <Link className="button" to="/booking">Book a Table</Link>
        {/* <Link className="button" to="/bookinggames">Book games</Link> */}
        <Link className="button" to="/editbooking">Edit Booking</Link>
        <Link className="button" to="/admindashboard">Admin</Link>
        {/* ✨ Add glow button here */}
        <button className="neon-button" onClick={toggleOffers}>
          Grab Your Offers <span className="arrow-down"></span>
        </button>
      </header>

      {/* 💥 Offers section - hidden until button is clicked */}
      {showOffers && (
        <section className="offers">
          {/* <div className="offer-card1"></div> */}
          {/* <div className="offer-card2"></div> */}
          <div className="offer-card3"></div>
          {/* <div className="offer-card4"></div> */}
        </section>
      )}

      <section className="about-us">
        <div>
          <Link to="/aboutus" className="button">What's the buzz? Know our space</Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
